export const CHAPTER_CONTENT_DELETION_REQUIRES_FORCE = 'CHAPTER_CONTENT_DELETION_REQUIRES_FORCE';

export const DRASTIC_DELETION_MIN_EXISTING_WORDS = 10;

export const DRASTIC_DELETION_MAX_REMAINING_RATIO = 0.1;
